import { ProjectPreview } from '../types/Project'

export const getAnchorLink = (id: string): string => {
  return `#${id}`
}

export const createProjectLink = (slug: ProjectPreview['slug']): string => {
  return `/portfolio/${slug}`
}
